import {useEffect, useState} from "react";
import DriverInfoSharedWrapper from "./driverInfoShared.styles";
import editVehicle from "../../../../../assets/images/edit-vehicle.svg";
import deleteVehicle from "../../../../../assets/images/delete-vehicle.svg";
import verticalLine from "../../../../../assets/images/vertical-line.svg";
import settings from "../../../../../assets/images/orange-settings.svg";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import save from "../../../../../assets/images/save.svg";
import {useDispatch, useSelector} from "react-redux";
import DriverForm from "../DriverForm/DriverForm";
import {removeDriver, setCustomerDetails, updateLocalDriver} from "../../../../../redux/actions/motorActions";
import {refactorDriversUtil} from "../../../../../helpers/refactor-drivers.util";
import {showErrorMessage} from "../../../../../redux/actions/commonActions";
import {getFullCustomerDetails} from "../../../../../services/motorRetailService";
import * as utils from '../../../helpers/utils';

const DriverInfoShared = () => {
    const width = window.innerWidth;
    const dispatch = useDispatch();
    const {personalFormDetails, customerDetails, drivers} = useSelector(state => state.motor)
    const [driverList, setDriverList] = useState([]);
    const [isEdit, setIsEdit] = useState({});
    const [genders, setGenders] = useState({});
    const [isAdd, setIsAdd] = useState(false);
    const [previewedDriver, setPreviewedDriver] = useState(null);

    const _loggedInDetails = {
        ...personalFormDetails,
        ...customerDetails
    }
    useEffect(() => {
        const loggedInCustomerDetails = refactorDriversUtil([_loggedInDetails])
        setDriverList(loggedInCustomerDetails)
    }, [])

    useEffect(() => {
        const _drivers = refactorDriversUtil([_loggedInDetails, ...drivers])
        setDriverList(_drivers)
        setIsAdd(false)
    }, [drivers])

    useEffect(() => {
        isAdd && setIsEdit(false)
    }, [isAdd])

    useEffect(() => {
        isEdit && setIsAdd(false)
    }, [isEdit])

    const optionsList = [
        {
            id: 'M',
            name: 'Male'
        },
        {
            id: 'F',
            name: 'Female'
        }
    ];

    const createDriver = (driver) => {
        const targetDriver = previewedDriver ?? driver
        const payload = {
            ...targetDriver,
            genderCode: utils.getGender(genders[targetDriver.nationalId])
        }
        // dispatch(removeDriver(payload.nationalId))
        dispatch(updateLocalDriver(payload))
        setIsEdit({[targetDriver.nationalId]: false})
        setPreviewedDriver(null)
    }

    const previewDriver = ({idNumber, yearOfBirth}) => {
        const exists = driverList?.filter(driver => driver.nationalId === idNumber)
        if (exists?.length) {
            dispatch(showErrorMessage("Driver already exists!"))
        } else {
            const formData = {
                ...customerDetails,
                nationalId: idNumber,
                yob: yearOfBirth
            }
            return getFullCustomerDetails(formData).then(response => {
                if (response) {
                    setPreviewedDriver({
                        ...response.customerInformation.policyHolder[0],
                        nationalId: response.idNumber,
                    })
                } else {
                    dispatch(showErrorMessage("Driver is not valid"))
                    throw Error("No data found");
                }
            }).then(() => {
                const toBePreviewed = refactorDriversUtil([previewedDriver]);
                setDriverList([...driverList, ...toBePreviewed])
                setIsEdit({[previewedDriver?.nationalId]: true})
            })
        }
    }

    const handleRemoveDriver = ({nationalId}) => {
        dispatch(removeDriver(nationalId))
    }

    return (
        <DriverInfoSharedWrapper>
            {driverList.map((eachDriver, index) => {
                return (
                    <div key={eachDriver?.fullName + index} className="driver-info-container">
                        <div className="driver-info-row">
                            <div className="driver-name-container">
                                <span className="driver-name-container title">Full Name</span>
                                <span className="driver-name-container value">
                  {eachDriver.fullName ?? 'N/A'}
                </span>
                            </div>
                            <div className="driver-id-container">
                <span className="driver-id-container title">
                  Saudi ID/Iqama
                </span>
                                <span
                                    className="driver-id-container value"
                                    key={eachDriver.nationalIdNumber + index}
                                >
                  {eachDriver.nationalId ?? 'N/A'}
                </span>
                            </div>
                            <div className="driver-birth-year-container">
                <span className="driver-birth-year-container title">
                  Year of Birth
                </span>
                                <span className="driver-birth-year-container value">
                  {eachDriver.yearOfBirth ?? 'N/A'}
                </span>
                            </div>
                            <div className="driver-gender-container">
                                <span className="driver-gender-container title">Gender</span>
                                <span className="driver-gender-container value">
                  {eachDriver.gender ?? 'N/A'}
                </span>
                            </div>
                            {width >= 768 && !isEdit[eachDriver.nationalId] && index !== 0 ? (
                                <div className="driver-info-container-right">
                                    <img
                                        src={verticalLine}
                                        alt="Save"
                                        className="driver-info-container-right-line"
                                    />
                                    <img
                                        src={editVehicle}
                                        alt="Save"
                                        onClick={() =>
                                            setIsEdit((state) => ({
                                                ...state,
                                                [eachDriver.nationalId]: !state[eachDriver.nationalId],
                                            }))
                                        }
                                        className="driver-info-container-right-edit"
                                    />
                                    <img
                                        src={deleteVehicle}
                                        alt="Save"
                                        onClick={() => handleRemoveDriver(eachDriver)}
                                        className="driver-info-container-right-delete"
                                    />
                                </div>
                            ) : null}
                            {width < 768 ? (
                                <img
                                    src={settings}
                                    alt="Save"
                                    className="driver-info-container-right-edit"
                                    onClick={() =>
                                        setIsEdit((state) => ({
                                            ...state,
                                            [eachDriver.nationalId]: !state[eachDriver.nationalId],
                                        }))
                                    }
                                />
                            ) : null}
                        </div>
                        {isEdit[eachDriver.nationalId] && (
                            <div className="driver-info-container-missing-info">
                                {width >= 768 ? <hr/> : null}
                                <p>Gender</p>
                                <div className="driver-info-container-row-edit">
                                    <Dropdown
                                        options={optionsList}
                                        optionLabel={"name"}
                                        optionValue={"id"}
                                        className="driver-info-container-edit-dropdown"
                                        value={genders[eachDriver.nationalId]}
                                        onChange={({target}) => setGenders({[eachDriver.nationalId]: target.value})}
                                    />
                                </div>
                                <hr/>
                                <div className="driver-info-container-edit-options">
                  <span
                      onClick={() => {
                          handleRemoveDriver(eachDriver.nationalId)
                          setIsEdit((state) => ({
                              ...state,
                              [eachDriver.nationalId]: !state[eachDriver.nationalId],
                          }))
                      }}
                  >
                    Close
                  </span>
                                    <Button
                                        className="driver-info-container-edit-options-save"
                                        label="Save"
                                        onClick={() => createDriver(eachDriver)}
                                    >
                                        <img
                                            src={save}
                                            alt="Save"
                                            className="driver-info-container-edit-options-save img"
                                        />
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}
            <div className="add-button-wrapper">
                <Button
                    type="button"
                    onClick={() => setIsAdd(!isAdd)}
                    className="button-primary float-right"
                    style={{marginRight: "1rem"}}>
                    Add Another Driver
                </Button>
            </div>
            {isAdd && <div className="driver-form-wrapper">
                <DriverForm {...{width}}
                            onSubmit={previewDriver}
                            onCloseClick={() => setIsAdd(false)}/>
            </div>}
        </DriverInfoSharedWrapper>
    );
};

export default DriverInfoShared;
